import React, { useEffect, useRef, useState } from 'react';
import { AvField } from "availity-reactstrap-validation"

const TinyMCEEditor = (props) => {
  const editorRef = useRef(null);
  const [content, setContent] = useState('');

  useEffect(() => {
    // console.log("approval conditions ==== ", props.value)
    // Initialize TinyMCE when the component mounts
    window.tinymce.init({
      selector: '#my-editor',
      license_key: 'gpl',
      height: 400,
      menubar: false,
      plugins: [
        'anchor',
        'code',
      ],
      toolbar:
        'undo redo | formatselect | bold italic backcolor | \
         alignleft aligncenter alignright alignjustify | \
         bullist numlist outdent indent | removeformat | help',
      setup: (editor) => {
        editorRef.current = editor;

        setContent(props.value)
        // console.log("conditional value => ", props.value)

        editor.on('change', () => {
          const newContent = editor.getContent(); // Get HTML content
          setContent(newContent); // Update state
          props.onChange(newContent)
        });

        editor.on('blur', () => {
          const finalContent = editor.getContent();
          // console.log('Editor blurred. Final content:', finalContent);
          props.onBlur?.(finalContent); 
        });
      },
    });

    // Cleanup TinyMCE instance when component unmounts
    return () => {
      if (editorRef.current) {
        window.tinymce.remove(editorRef.current);
      }
    };
  }, []);


  return (
    <div>
      {props.label? <h5>{props.label}</h5> : <h4>Approval Conditions</h4>}

      <input value={content} type='textarea' id='my-editor' required></input>
   
    </div>
  );
};

export default TinyMCEEditor;
